// extracted by mini-css-extract-plugin
export default {"bigblue":"mystyle_bigblue__X2Tzi"};